import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { prop } from 'ramda';

import { useAppSelector } from 'js/store/hooks';
import { useLoginPopup } from 'js/components/popups/LoginPopup/hooks';
import { setShowPopupAlreadyUser } from 'js/components/system/App/store/buzz/actions';
import { useNavigateToPopupBackgroundPage } from 'js/components/system/Router/components/PageRouter/hooks';

export const useModalAlreadyUser = () => {
    const dispatch = useDispatch();
    const showLoginPopup = useLoginPopup();
    const isShowPopupAlreadyUser = useAppSelector(prop('isShowPopupAlreadyUser'));
    const navigateToPopupBackgroundPage = useNavigateToPopupBackgroundPage();

    const handlerSwitchPopupAlreadyUser = useCallback((isShow) => {
        dispatch(setShowPopupAlreadyUser(isShow));
    }, [dispatch]);

    const handlerOpenPopupAlreadyUser = useCallback(() => {
        handlerSwitchPopupAlreadyUser(true);
        navigateToPopupBackgroundPage();
    }, [handlerSwitchPopupAlreadyUser, navigateToPopupBackgroundPage]);

    const handlerClosePopupAlreadyUser = useCallback(() => {
        handlerSwitchPopupAlreadyUser(false);
        showLoginPopup();
    }, [handlerSwitchPopupAlreadyUser, showLoginPopup]);

    return useMemo(() => ({
        isShowPopupAlreadyUser,
        closePopupAlreadyUser: handlerClosePopupAlreadyUser,
        openPopupAlreadyUser: handlerOpenPopupAlreadyUser
    }), [handlerClosePopupAlreadyUser, handlerOpenPopupAlreadyUser, isShowPopupAlreadyUser]);
};

